module.exports = __webpack_public_path__ + "img/lbl-02.de66f3b4.png";